import { render, staticRenderFns } from "./organization-asset-group-survey-members-form.vue?vue&type=template&id=71846d8a&"
import script from "./organization-asset-group-survey-members-form.vue?vue&type=script&lang=js&"
export * from "./organization-asset-group-survey-members-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports